import mainStore from '@/store';

class ModalService {
  constructor(store) {
    this.$store = store;
    this._title = null;
    this._content = null;
    this._actions = null;
  }

  get title() {
    return this._title;
  }

  get content() {
    return this._content;
  }

  get actions() {
    return this._actions;
  }

  get modalData() {
    return {
      title: this._title,
      content: this._content,
      subtitle: this.content,
      actions: this._actions,
    };
  }

  setData({ title, content, actions }) {
    this._title = title || null;
    this._content = content || null;
    this._actions = actions || null;
  }
}

const modalService = new ModalService(mainStore);

export default modalService;
